export default __webpack_public_path__ + "static/media/emoji-maroc.9871378c.svg";